
































import {
  Vue, Component, Watch, Prop,
} from 'vue-property-decorator';
import { User } from '@/types';

@Component
export default class DeleteUserDialog extends Vue {
  @Prop(Boolean) readonly value!: boolean

  @Prop(Object) readonly user!: User|null

  dialog = false

  loading = false

  @Watch('value')
  onValueChanged(val: boolean, oldVal: boolean) {
    this.dialog = val;
  }

  @Watch('dialog')
  onDialogChanged(val: boolean, oldVal: boolean) {
    if (this.value !== val) {
      this.$emit('input', val);
    }
  }

  cancel() {
    this.dialog = false;
  }

  async deleteItem() {
    if (this.user && this.user.id) {
      this.loading = true;

      await this.$store.dispatch('deleteUser', { user: this.user });

      this.loading = false;
      this.dialog = false;
    }
  }
}
